import { useEffect, useRef } from 'react';

function useTimeout(callback, delay) {
	const callbackRef = useRef(callback);

	// Update ref when callback changes
	useEffect(() => {
		callbackRef.current = callback;
	}, [callback]);

	// Set up timeout
	useEffect(() => {
		let timer;

		// If delay is valid and callback is a function, start timeout
		if (delay !== null && delay !== undefined && typeof callback === 'function') {
			timer = setTimeout(callbackRef.current, delay);
		}

		// Clean up timeout on unmount or delay change
		return () => {
			if (timer) {
				clearTimeout(timer);
			}
		};
	}, [delay]);
}

export default useTimeout;
